import { apiRequest } from '../../../api/client';
import type { FacilityCreateResponseDto, FacilityListResponseDto } from '../types/facility';

export function listFacilities(customerId: string): Promise<FacilityListResponseDto> {
  return apiRequest<FacilityListResponseDto>(`/v1/customers/${encodeURIComponent(customerId)}/facilities`);
}

export function createFacility(customerId: string, input: { facilityName: string; location: string | null }): Promise<FacilityCreateResponseDto> {
  return apiRequest<FacilityCreateResponseDto>(`/v1/customers/${encodeURIComponent(customerId)}/facilities`, {
    method: 'POST',
    body: JSON.stringify({ facility_name: input.facilityName, location: input.location }),
  });
}
